import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgWizardConfig, NgWizardService, THEME } from 'ng-wizard'
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs/internal/Subscription';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormErrorService } from 'src/app/shared/form-validation/form-error.service';
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
declare var $: any;
import { ApiService } from 'src/app/shared/services/apiService.service';
import { formatDate } from '@angular/common';
import { RootService } from 'src/app/shared/services/root.service';
import { NgxSpinnerService } from "ngx-spinner";
import { DatePipe } from '@angular/common'
import { isPlatformBrowser } from '@angular/common';
import { ClevertapService } from '../../shared/services/clevertap/clevertap.service';
import { environment } from '../../../environments/environment';
import { RegexService } from 'src/app/shared/form-validation/regex.service';
import { CommonService } from '../../shared/services/common.service';


@Component({
  selector: 'app-book-test-drive',
  templateUrl: './book-test-drive.component.html',
  styleUrls: ['./book-test-drive.component.scss']
})
export class BookTestDriveComponent implements OnInit {
  sub: Subscription = new Subscription
  showEmailError: boolean = false;
  environment1 = environment.s3bucket.url;
  config: NgWizardConfig = {
    selected: 0,
    theme: THEME.arrows,
    toolbarSettings: {
      showPreviousButton: false,
      showNextButton: false,
    }
  };
  productId: any;
  breadcrumbData: any
  td_type: any;
  lob: any;
  stateList: any;
  testDriveForm!: FormGroup;
  testDriveDoorStepForm: FormGroup;
  personalInfoForm!: FormGroup
  dealerList: any;
  districtList: any;
  cityList: any;
  statedata: any;
  daysList = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  timeList = ["10-11", "11-12", '12-1', "1-2", "2-3", "3-4", "4-5", "5-6", "6-7"];
  isShowTime: boolean = false
  isDoorStep: boolean = false
  isShowPersonalInfo: boolean = false
  isShowConfirmation: boolean = false
  isShowPopup: boolean = false
  dateList: any[] = [];
  selectedDateTime: any;
  userData: any
  afterBookingDataList: any;
  selctedTime: any;
  breadcrumbList: { label: any; url: string; pageName: string; };
  productDetailList: any;
  breadcrumbdata: any = [];
  showBreadCrumb: boolean = false;
  isTestDriveDoorstepSubmitted: boolean = false;
  doorStepAddressData: any = [];
  featureList: any = [];
  imageUrl: any;
  divData: any;
  productLoaded: boolean = false
  selectedRadiobtnId: any = null;
  url: any;
  newVCPrice: any;
  isdealer:boolean=false;
  dealerCode:any;
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onPageView("Book Test Drive");
      } catch { }
    }
    this.userData = this.secureService.getUserData()
    this.isTestDriveDoorstepSubmitted = false;
    this.activatedRoute.paramMap.subscribe(params => {
      this.productId = params.get('id')
    })
    this.bookTestDriveForm();
    this.resetPersonalInfo();
    if (localStorage.getItem("dealercd")) {
      this.isdealer=true;
      this.dealerCode=localStorage.getItem("dealercd")
    }
    this.selectTestDrive('At showroom');
    this.generateDates();
    this.getVehicleDetail();
  }
  showPreviousStep() {
    this.ngWizardService.previous();
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.testDriveForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  showNextStep() {
    if (this.td_type != 'At Doorstep') {
      if (this.testDriveForm.status == 'INVALID') {
        this.toastrService.warning("Please select Values")
        return
      }
    }
    else {
      if (this.testDriveDoorStepForm.status == 'INVALID') {
        this.toastrService.warning("Please select Values")
        return
      }
    }

    if (!this.selectedDateTime) {
      this.toastrService.warning("Please select Date")
      return
    }

    this.ngWizardService.next();
    this.isShowPersonalInfo = true

    if (this.userData === null || undefined || "")
      this.isShowPopup = true
    this.personalInfoForm.controls['firstName'].patchValue(this.userData.first_name)
    this.personalInfoForm.controls['lastName'].patchValue(this.userData.last_name)
    this.personalInfoForm.controls['mobileNo'].patchValue(this.userData.mobile_number)
    this.personalInfoForm.controls['email'].patchValue(this.userData.email_id)
    window.scrollTo(0, 0);
  }

  showPersonalInfo() {
    try {
      if (this.personalInfoForm.invalid) {
        if (this.personalInfoForm.controls['email'].value && this.personalInfoForm.controls['email'].errors['pattern']) {
          this.toastrService.warning('Please add valid email id');
          return;
        }

        // this.toastrService.warning('Please fill all mandatory details');
        // return;
      }
      if (this.personalInfoForm.status == 'INVALID') {
        this.formErrorService.displayFormErrors(this.personalInfoForm);
        return;
      }
      window.scrollTo(0, 0);
      this.ngWizardService.next();
      let state = this.testDriveForm.value.state ? this.testDriveForm.value.state : this.testDriveDoorStepForm.value.state
      let statedata = state.split(",")
      const data: Input = {} as Input;
      data.product_id = this.productId;
      data.mobile_number = this.personalInfoForm.controls['mobileNo'].value;
      data.district = this.testDriveForm.controls['district'].value ? this.testDriveForm.controls['district'].value : this.testDriveDoorStepForm.controls['district'].value;
      data.state = statedata[0];
      data.scheduled_on = this.datepipe.transform(this.selectedDateTime, 'yyyy-MM-dd h:mm:ss');
      data.division_id = this.testDriveForm.value.dealer ? this.testDriveForm.value.dealer : this.testDriveDoorStepForm.value.dealer;
      data.first_name = this.personalInfoForm.controls['firstName'].value;
      data.last_name = this.personalInfoForm.controls['lastName'].value;
      data.td_type = this.td_type;
      if (this.td_type == 'Online Demo') {
        var time = this.selctedTime.split('-');

        data.slot_start_time = time[0];
        data.slot_end_time = time[1];
      }
      this.spinner.show();

      this.sub.add(this.apiService.addBookTestDrive(data).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.spinner.hide();
            this.isShowConfirmation = true
            this.afterBookingDataList = res.data
            this.toastrService.success(res.data.msg)
            if (isPlatformBrowser(this.platformId)) {
              if (this.td_type == 'At Doorstep') {
                this.divData = this.dealerList.filter(item => item.division_id == this.testDriveDoorStepForm.value.dealer)

              }
              try {
                let dateForTestDrive = formatDate(
                  this.selectedDateTime,
                  "dd-MM-yyyy", "en-US");

                this.cleverService.onTestRideBooked(
                  this.productDetailList["id"],
                  this.productDetailList["model"],
                  this.imageUrl,
                  this.productDetailList["sub_lob"],
                  this.productDetailList["lob"],
                  this.productDetailList["ppl"],
                  data['first_name'],
                  data['last_name'],
                  data['state'],
                  data['district'],
                  this.divData[0].division_name,
                  dateForTestDrive,
                  this.url,
                  this.td_type
                );
              } catch {
                return
              }
            }
          } else {
            this.spinner.hide();
            this.isShowPersonalInfo = true;
            this.toastrService.warning(res.data.msg)

          }

        },
        error: () => {
          this.spinner.hide();
        }
      }))
    } catch (error) {
      this.spinner.hide();
    }
  }

  resetWizard() {
    this.ngWizardService.reset();
  }

  setTheme(theme: THEME) {
    this.ngWizardService.theme(theme);
  }

  stepChanged() {
  }


  isValidTypeBoolean: boolean = true;

  isValidFunctionReturnsBoolean() {
    return true;
  }

  isValidFunctionReturnsObservable() {
    return true;
  }



  constructor(private ngWizardService: NgWizardService, private activatedRoute: ActivatedRoute, private apiService: ApiService,
    private toastrService: ToastrService, private localStorage: secureStorage, private regexService: RegexService,
    private formBuilder: FormBuilder, private formErrorService: FormErrorService,
    private secureService: RootService, private spinner: NgxSpinnerService, public datepipe: DatePipe, private CommonService: CommonService,
    private cleverService: ClevertapService, @Inject(PLATFORM_ID) private platformId: Object) {
  }

  bookTestDriveForm() {
    let dealer= localStorage.getItem("dealercd")
    this.testDriveForm = this.formBuilder.group({
      state: ["",dealer?'': Validators.required],
      district: ["", dealer?'':Validators.required],
      city: ["",dealer?'': Validators.required],
      dealer: ["", Validators.required],
      time: [""]
    })

    this.testDriveDoorStepForm = this.formBuilder.group({
      state: ["", Validators.required],
      district: ["", Validators.required],
      city: ["", Validators.required],
      address: ["", Validators.required],
      defaultAddress: [false],
      dealer: ['', Validators.required]
    })
  }


  resetPersonalInfo() {
    this.personalInfoForm = this.formBuilder.group({
      // firstName: ["",  [Validators.required, Validators.pattern(this.regexService.MultilingualAlphabet)]],
      firstName: [
        this.userData.first_name ? this.CommonService.replaceUnicode(this.userData.first_name) : "",
        [Validators.required,]
      ],
      lastName: [
        this.userData.last_name ? this.CommonService.replaceUnicode(this.userData.last_name) : "",
        [Validators.required]
      ],
      mobileNo: ["", [Validators.required, Validators.pattern(this.regexService.Phone)]],
      email: [""]
    })
  }
  dateScheduleOption: OwlOptions = {
    // loop: true,
    autoWidth: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    nav: true,
    margin: 10,
    navText: [
      `<img alt="left" src=${this.environment1}assets/images/chevron-left.svg>`,
      `<img alt="right" src=${this.environment1}assets/images/chevron-right.svg>`
    ],

    responsive: {
      0: {
        items: 3.4,
        // nav: false
      },
      740: {
        items: 6,
        // nav: false
      },

      940: {
        items: 6,
        // nav: true
      }
    }

  }


  alphanumbericOnlyFirstLastName(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/[a-zA-Z]|[.]|[ ]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  // onFocusOutRemoveSpace(event: any) {
  //   let value = (event.target.value).replace(/\s/g, "")
  //   this.personalInfoForm.patchValue({ lastName: value })
  // }
  selectTestDrive(value: any) {
    this.selectedDateTime = null;
    if (this.selectedRadiobtnId) {
      (<HTMLInputElement>document.getElementById(this.selectedRadiobtnId)).checked = false;
    }
    this.isTestDriveDoorstepSubmitted = false;

    this.td_type = value;
    this.dealerList = [];
    this.districtList = [];
    this.cityList = [];
    this.testDriveForm.controls['state'].setValue('');
    this.testDriveForm.controls['time'].setValidators(null);
    this.testDriveForm.controls['time'].updateValueAndValidity();
    this.testDriveForm.controls['district'].setValue('');
    this.testDriveForm.controls['city'].setValue('');
    this.testDriveForm.controls['dealer'].setValue('');
    this.testDriveDoorStepForm.controls['district'].setValue('');
    this.testDriveDoorStepForm.controls['city'].setValue('');
    this.testDriveDoorStepForm.controls['dealer'].setValue('');
    if (this.isdealer && this.lob) {
      this.getDealerlogin()
    }
    if (value === "At Doorstep") {
      this.getDataAtDoorStep();
      this.isDoorStep = true;
    }
    else { this.isDoorStep = false }
    if (value === "Online Demo") {
      this.isShowTime = true
      this.testDriveForm.controls['time'].setValidators(Validators.required);
      this.testDriveForm.controls['time'].updateValueAndValidity();
    }
    else {
      this.isShowTime = false
    }
  }
  getState() {
    try {
      let data = {
        lob: this.lob
      }
      this.spinner.show();
      this.sub.add(this.apiService.getLocations(data).subscribe({
        next: (res: any) => {
          this.spinner.hide();
          this.stateList = res.data
        },
        error: () => {
          this.spinner.hide();
        },
        complete: () => {
          this.spinner.hide();
        }
      }))
    } catch (error) {
      this.spinner.hide();
    }
  }

  getDistrictList() {
    try {
      this.districtList = [];
      this.dealerList = [];
      this.cityList = [];
      let state = this.testDriveForm.value.state;

      if (this.td_type == 'At Doorstep') {
        state = this.testDriveDoorStepForm.value.state;
        this.testDriveDoorStepForm.controls['district'].setValue('');
        this.testDriveDoorStepForm.controls['city'].setValue('');
        this.testDriveDoorStepForm.controls['dealer'].setValue('');

      } else {
        this.testDriveForm.controls['district'].setValue('');
        this.testDriveForm.controls['city'].setValue('');
        this.testDriveForm.controls['dealer'].setValue('')
      }
      let statedata = state.split(",");
      let dummyList = {};
      dummyList = {
        code: statedata[1],
        state: statedata[0],
      };

      let stateData = {
        state: dummyList,
        lob: this.lob,
      };
      this.spinner.show();
      this.sub.add(this.apiService.getLocations(stateData).subscribe({
        next: (response: any) => {
          if (response["success"]) {
            this.spinner.hide();
            this.districtList = response["data"];
          }
        },
        error: () => {
          this.spinner.hide();
        },
        complete: () => {
          this.spinner.hide();
        }
      })
      );
    }
    catch (error) {
      this.spinner.hide();
    }

  }

  getCity() {
    try {
      this.cityList = [];
      this.dealerList = [];
      let st = this.testDriveForm.value.state;
      let dictData = this.testDriveForm.value.district;
      if (this.td_type == 'At Doorstep') {
        st = this.testDriveDoorStepForm.value.state;
        dictData = this.testDriveDoorStepForm.value.district;
        this.testDriveDoorStepForm.controls['city'].setValue('');
        this.testDriveDoorStepForm.controls['dealer'].setValue('');
      } else {
        this.testDriveForm.controls['city'].setValue('');
        this.testDriveForm.controls['dealer'].setValue('');
      }
      let state = st.split(",");
      let ll = {};
      ll = {
        code: state[1],
        name: state[0],
      };

      let district = {
        district: dictData,
        state: ll,
      }
      this.spinner.show();
      this.sub.add(this.apiService.getCityList(district).subscribe({
        next: (res: any) => {
          this.cityList = res;
        },
        error: () => {
          this.spinner.hide();
        },
        complete: () => {
          this.spinner.hide();
        }
      }))
    } catch (error) {
      this.spinner.hide();
    }
  }

  generateDates() {
    this.dateList = []
    var today = new Date();
    for (let i = 1; i < 30; i++) {
      var priorDate = new Date(new Date().setDate(today.getDate() + i));
      let dd = formatDate(priorDate, 'dd MMM', 'en-GB')
      let convertDate = formatDate(priorDate, 'yyyy-MM-dd', 'en-GB')
      let day = priorDate.getDay()
      let dayValue = this.daysList[day]
      this.dateList.push({ convertDate, dayValue, dd })
    }


  }

  getDealer() {
    try {
      this.dealerList = [];
      let state = this.testDriveForm.value.state ? this.testDriveForm.value.state : this.testDriveDoorStepForm.value.state;
      this.statedata = state.split(",");
      let ll = {};
      ll = {
        code: this.statedata[1],
        state: this.statedata[0],
      };
      let data = {
        district: this.testDriveForm.value.district ? this.testDriveForm.value.district : this.testDriveDoorStepForm.value.district,
        state: this.statedata[1],
        lob_name: this.lob ? this.lob : "",
      };
      if (this.td_type == 'At Doorstep') {
        this.testDriveDoorStepForm.controls['dealer'].setValue('');
      } else {
        this.testDriveForm.controls['dealer'].setValue('')
      }
      this.spinner.show();
      this.sub.add(this.apiService.getDealerList(data).subscribe({
        next: (response: any) => {
          this.spinner.hide();
          if (response["success"]) {
            this.dealerList = response["data"];
          } else {
            this.dealerList = [];
          }
        },
        error: () => {
          this.spinner.hide();
        },
        complete: () => {
          this.spinner.hide();
        }
      })
      );
    } catch (error) {
      this.dealerList = [];
      this.spinner.hide();
    }
  }
  selectedTime(value: any, flag: any, index: any) {

    if (flag == 'date') {
      this.selectedDateTime = value
      this.selectedRadiobtnId = "check" + index;

    }
    else if (flag == 'time') {
      this.selctedTime = value;
      this.testDriveForm.controls['time'].setValue(value)
      // if (this.td_type == 'Online Demo') {
      this.selectedDateTime = this.selectedDateTime + ' ' + this.testDriveForm.controls['time'].value
      // }
    }
  }

  onDealerSelection() {
    this.divData = this.dealerList.filter(
      (division) => division.division_id == this.testDriveForm.value.dealer

    );
    if (this.td_type == 'At Doorstep') {
      this.divData = this.dealerList.filter(item => item.division_id == this.testDriveDoorStepForm.value.dealer)
    }


    let priceData = {
      "dealer_code": this.divData[0].dealer_code,
      "vc_number": this.productDetailList["vehicle_number"] ? this.productDetailList["vehicle_number"] : ""
    }
    this.getVCPrice(priceData)

  }
  getVCPrice(data) {

    this.sub.add(this.apiService.getDealerPrice(data).subscribe({
      next: (response: any) => {
        this.newVCPrice = response?.data?.dealer_price ? response.data.dealer_price : null;

      },
      error: () => { },
      complete: () => { }
    }))
  }
  getVehicleDetail() {
    try {
      let data = {
        product_id: this.productId
      }
      this.spinner.show();
      this.sub.add(this.apiService.getVehicleDetails(data).subscribe({
        next: (res: any) => {
          this.spinner.hide();
          this.productDetailList = res?.data;
          this.productLoaded = true
          this.imageUrl = this.productDetailList["images"][0].image_url;
          this.lob = this.productDetailList["lob"];
          if (this.isdealer) {
            this.getDealerlogin();
          }
          this.getState();
          this.breadcrumb();
          this.getFeatures();
        },
        error: () => {
          this.spinner.hide();
          this.productDetailList = [];
          this.productLoaded = true
        },
        complete: () => {
          this.spinner.hide();
          this.productLoaded = true
        }
      }))
    } catch (error) {
      this.spinner.hide();
      this.productLoaded = true
    }
  }
  breadcrumb() {

    localStorage.removeItem('sideFilter')
    localStorage.removeItem("ExploreMappedData")
    localStorage.removeItem("ExploreMappedData1")
    localStorage.removeItem('ExploreMappedDatatype')
    localStorage.removeItem('ExploreMappedDatamodal')
    localStorage.removeItem("explore")
    localStorage.removeItem("EModeldData")
    localStorage.removeItem('localBreadCrumb');
    localStorage.removeItem("exploreData")
    localStorage.removeItem("UrlData")
    this.breadcrumbList = {
      label: this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'Trucks' : this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'buses' ? 'Buses & Vans' : this.productDetailList.sub_lob,
      url: `/product-list/` + (this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase()),
      pageName: 'product-details',
    };

    this.breadcrumbdata.push(this.breadcrumbList);
    this.breadcrumbList = {
      label: this.productDetailList.lob,
      url: `/category-list/` + (this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase()) + `/` + this.productDetailList.lob?.replace(/\s/g, "-")?.toLowerCase(),
      pageName: 'product-details',
    };
    this.breadcrumbdata.push(this.breadcrumbList);
    this.breadcrumbList = {
      label: this.productDetailList.ppl,
      url: `/product-list/` + (this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase()) + `/` + this.productDetailList.lob?.replace(/\s/g, "-")?.toLowerCase() + `/` + this.productDetailList.ppl?.replace(/\s/g, "-").replace("---", "-")?.toLowerCase(),
      pageName: 'product-list',

    };
    this.breadcrumbdata.push(this.breadcrumbList);
    this.breadcrumbList = {
      label: this.productDetailList.model,
      url: `/product-details/` + (this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase()) + `/` + this.productDetailList.lob.replace(/\s/g, '-')?.toLowerCase() +
        `/` + this.productDetailList.ppl.replace(/\s/g, '-').replace('---', '-')?.toLowerCase() +
        `/` + ((this.productDetailList.model.replace(/\//g, "-").replace(/\+/g, "-").replace(/\./g, "-")?.toLowerCase())) +
        `/` + this.productDetailList.id,
      pageName: 'product-details',
    };
    this.breadcrumbdata.push(this.breadcrumbList);
    this.breadcrumbList = {
      label: 'book test drive',
      url: '',
      pageName: 'booking',
    };
    this.breadcrumbdata.push(this.breadcrumbList);

    this.localStorage.setItem(
      'localBreadCrumb',
      JSON.stringify(this.breadcrumbdata)
    );

    this.showBreadCrumb = true;
  }

  saveProceed() {

    try {
      if (this.testDriveDoorStepForm.invalid) {
        this.toastrService.warning("Please fill all details")
        return
      }

      if (!this.testDriveDoorStepForm.controls['address'].value) {
        this.toastrService.warning('Please add valid address');
        return;

      }
      let data = {
        "action_type": "add",
        "address_line_1": this.CommonService.replaceUnicode(this.testDriveDoorStepForm.value.address),
        "address_line_2": " ",
        "city": this.testDriveDoorStepForm.value.city,
        "pincode": "",
        "district": this.testDriveDoorStepForm.value.district,
        "taluka": "",
        "state": this.testDriveDoorStepForm.value.state,
        "state_code": "",
        "country": "India",
        "is_active": 1,
        "is_default": this.testDriveDoorStepForm.value.defaultAddress == true ? 1 : 0,
        "user_id": null,
        "dealer_name": this.testDriveDoorStepForm.value.dealer
      }
      if (this.doorStepAddressData?.length > 0) {
        data.action_type = 'edit'
        data.user_id = this.doorStepAddressData[0].id
      }
      this.spinner.show();
      this.sub.add(this.apiService.saveAtDoorStep(data).subscribe({
        next: (res: any) => {
          this.spinner.hide();
          if (res.success) {
            this.toastrService.success(res.data.msg)
            this.isTestDriveDoorstepSubmitted = true;
            var element = document.getElementById('atDoorStepCloseBtn');
            this.selectTestDrive('At Doorstep')
            element.click();
          } else {
            this.toastrService.warning(res.data.msg);
          }

        },
        error: (err) => {
          this.toastrService.warning(err);
          this.spinner.hide();
        },
        complete: () => {
          this.spinner.hide();
        }
      }))
    } catch (error) {
      this.spinner.hide();
    }
  }

  getDataAtDoorStep() {
    try {
      let data = {
        "offset": 0,
        "size": 5
      }
      this.spinner.show();
      this.sub.add(this.apiService.getDataAtDoorStep(data).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.spinner.hide();
            this.isTestDriveDoorstepSubmitted = true;
            this.doorStepAddressData = res.data;
            this.testDriveDoorStepForm.controls['defaultAddress'].setValue(this.doorStepAddressData[0].is_default);
            this.testDriveDoorStepForm.controls['address'].setValue(this.doorStepAddressData[0].address_line_1);
            this.testDriveDoorStepForm.controls['state'].setValue(this.doorStepAddressData[0].state);
            // this.testDriveDoorStepForm.controls['dealer'].setValue(this.doorStepAddressData[0].dealer_name)
            if (this.doorStepAddressData?.length > 0) {
              setTimeout(() => {
                if (this.districtList) {
                  this.getDistrictList();
                }
              }, 200);

              setTimeout(() => {
                if (this.districtList) {
                  this.testDriveDoorStepForm.controls['district'].setValue(this.doorStepAddressData[0].district);
                  this.getCity();
                }
              }, 200);
              setTimeout(() => {
                if (this.cityList) {
                  this.testDriveDoorStepForm.controls['city'].setValue(this.doorStepAddressData[0].city);
                  this.getDealer();
                }
              }, 200);
              setTimeout(() => {
                if (this.dealerList) {
                  this.testDriveDoorStepForm.controls['dealer'].setValue(this.doorStepAddressData[0].dealer_name)
                }
              }, 200);
            }
          }
          else {
            this.doorStepAddressData = [];
          }
        }, error: () => {
          this.doorStepAddressData = [];
          this.spinner.hide();
        },
        complete: () => {
          this.spinner.hide();

        }
      }))
    } catch (error) {
      this.spinner.hide();
      this.doorStepAddressData = [];
    }
  }

  getFeatures() {
    let data = {
      "ppl": this.productDetailList.ppl,
      "vc_number": this.productDetailList["vehicle_number"] ? this.productDetailList["vehicle_number"] : ""
    }
    this.sub.add(this.apiService.getFeatureList(data).subscribe({
      next: (res: any) => {
        let dummyValue = res?.data
        if (dummyValue?.length == 3) {
          this.featureList = dummyValue.slice(1);
        }
        else {
          this.featureList = res?.data
          this.featureList = this.featureList?.slice(0, 4);
        }
      },
      error: () => { },
      complete: () => {
        if (isPlatformBrowser(this.platformId)) {
          try {
            let sublob =
              this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
                'icv-trucks'
                ? 'trucks'
                : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
                  'buses'
                  ? 'buses-vans'
                  : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase();
            let model = this.productDetailList.model
              .replace(/\s/g, '-')
              .replace(/\//g, '-')
              .replace(/\+/g, '-')
              .replace(/\./g, '-')
              ?.toLowerCase();
            this.url =
              '/lead-booking/' +
              sublob +
              '/' +
              this.productDetailList.lob_seo +
              '/' +
              this.productDetailList.ppl_seo +
              '/' +
              model +
              '/' +
              this.productDetailList.id;

            this.cleverService.onTestRideInitiated(
              this.productDetailList["id"],
              this.productDetailList["model"],
              this.imageUrl,
              this.productDetailList["sub_lob"],
              this.productDetailList["lob"],
              this.productDetailList["ppl"],
              this.productDetailList['price_range'] ? this.productDetailList['price_range'] : "",
              this.productDetailList['down_payment'],
              this.featureList[0]?.description ? this.featureList[0]?.description : "",
              this.featureList[1]?.description ? this.featureList[1]?.description : "",
              this.featureList[2]?.description ? this.featureList[2]?.description : "",
              this.featureList[3]?.description ? this.featureList[3]?.description : "",
              this.url

            );
          } catch { }
        }
      }
    }))
  }

  notAllowSpace(event: any) {
    if ((event.target.selectionStart === 0 && event.which === 32) || event.key === '.') {
      event.preventDefault();
    }
  }
  emailValidator(event) {
    this.showEmailError = false;
    let email = event.target.value;
    var validRegex = '^.+@.+\\..+$';

    if (email.match(validRegex)) {
      this.showEmailError = false;
    }
    else {
      this.showEmailError = true;
    }
    if (email?.length == 0) {
      this.showEmailError = false;
    }
  }
  getDealerlogin() {
    try {

      let data={
        'lob_name':this.lob ? this.lob : "",
        'dealer_code':this.dealerCode
      }

      if (this.td_type == 'At Doorstep') {
        this.testDriveDoorStepForm.controls['dealer'].setValue('');
      } else {
        this.testDriveForm.controls['dealer'].setValue('')
      }
      this.spinner.show();

      this.sub.add(this.apiService.getDealerList(data).subscribe({
        next: (response: any) => {
          this.spinner.hide();
          if (response["success"]) {
            this.dealerList = response["data"];
          } else {
            this.dealerList = [];
          }
        },
        error: () => {
          this.spinner.hide();
        },
        complete: () => {
          this.spinner.hide();
        }
      })
      );
    } catch (error) {
      this.dealerList = [];
      this.spinner.hide();
    }
  }
  nAllowSpace(event: KeyboardEvent) {
    if (event.key === ' ') {
      event.preventDefault();
    }
  }
  public hasRequiredError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasRequiredError(controlName, this.testDriveForm);

  public hasPatternError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasPatternError(controlName, this.testDriveForm);

  public hasRequiredError1 = (controlName: string): boolean | undefined =>
    this.formErrorService.hasRequiredError(controlName, this.personalInfoForm);

  public hasPatternError1 = (controlName: string): boolean | undefined =>
    this.formErrorService.hasPatternError(controlName, this.personalInfoForm);
}
export interface Input {
  product_id: any;
  mobile_number: any;
  district: any;
  state: any;
  scheduled_on: any;
  division_id: any;
  first_name: any;
  last_name: any;
  td_type: any;
  slot_start_time: any;
  slot_end_time: any;
}
